import React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core'
import { IAlertDialogProps } from './Interfaces'

const AlertDialog: React.FC<IAlertDialogProps> = ({ title, isOpen, content, onClose, size, closeButtonText }) => {
  return (
    <React.Fragment>
      <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth={size} aria-labelledby="alert-dialog-title">
        <DialogTitle id="alert-dialog-title" style={{ color: 'rgb(52, 27, 108)' }}>
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{content}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary" id="alert-dialog-close-button">
            {closeButtonText ? closeButtonText : 'Close'}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}

export default AlertDialog
